import api from '../../api';
import { faBalanceScale } from '@fortawesome/free-solid-svg-icons';

export const PAGE_CONFIG = (tr) => ({
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: tr('pageTitle'), link: '/regional-cases' }
    ],
    PAGE_TITLE: tr('pageTitle'),
    PAGE_DESCRIPTION: tr('pageDescription'),
    GET_QUERY_KEY: 'regionalCases',
    SEARCH_DESCRIPTION: tr('searchDescription'),
    SEARCH_PLACEHOLDER: tr('searchPlaceholder'),
    EMPTY_PAGE_ICON: faBalanceScale,
    SEARCH_LOADING_MESSAGE: tr('searchLoadingMessage'),
    API_CALL: () => api.upload.getUploads(),
    DEFAULT_ERROR_MESSAGE: tr('defaultErrorMessage'),
    SELECT: (data) => data?.data
});
